
import ajax from './ajax';


export async function accountActivation(data) {
     return ajax('/resources/account-activation/', { method: 'POST', data })
}